﻿import React from 'react';

//Custom imports
import PdfFileIcon from '../../Components/svg/PdfFileIconSvg';
import ImageFile from '../../Components/svg/ImageFile';
import UnknownFileIcon from '../../Components/svg/UnknownFileIconSvg';

const DocumentFileIcon = (props) => {
  const { fileName, ...rest } = props;

  const iconMap = {
    jpg: ImageFile,
    jpeg: ImageFile,
    png: ImageFile,
    gif: ImageFile,
    bmp: ImageFile,
    pdf: PdfFileIcon,
  };
  const extension = fileName && fileName.split('.').pop();
  const IconComponent = iconMap[extension.toLowerCase()] || UnknownFileIcon;
  return <IconComponent {...rest} />;
};

export default DocumentFileIcon;
